var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramMasterCard40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MasterCard40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Note",
    transform: "translate(7.000000, 12.500000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("g", {
    id: "mc_symbol",
    transform: "translate(3.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 33,
    height: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 4.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF5F00",
    x: 9.45753155,
    y: 1.66967312,
    width: 6.86248739,
    height: 12.2796727
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89328861,7.80950946 C9.89109158,5.41325035 10.9957228,3.14910895 12.888797,1.66967312 C9.6732625,-0.847072262 5.05527512,-0.480769357 2.28042993,2.51113833 C-0.494415269,5.50304601 -0.494415269,10.1159729 2.28042993,13.1078806 C5.05527512,16.0997883 9.6732625,16.4660912 12.888797,13.9493458 C10.9957358,12.4698995 9.89110789,10.2057648 9.89328861,7.80950946 Z",
    id: "Path",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5779066,7.80950946 C25.5779066,10.7993918 23.8637098,13.5268891 21.163038,14.833654 C18.4623661,16.1404189 15.2494525,15.7970393 12.888797,13.9493458 C14.7801043,12.4684934 15.8842841,10.205261 15.8842841,7.80950946 C15.8842841,5.41375791 14.7801043,3.15052551 12.888797,1.66967312 C15.2494525,-0.178020371 18.4623661,-0.521400011 21.163038,0.785364906 C23.8637098,2.09212982 25.5779066,4.81962707 25.5779066,7.80950946 L25.5779066,7.80950946 Z",
    id: "Path",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6248513,13.9080233 L25.6248513,12.6104668 L26.2407604,12.6104668 L26.2407604,12.3461186 L24.672189,12.3461186 L24.672189,12.6104668 L25.2883617,12.6104668 L25.2883617,13.9080233 L25.6248513,13.9080233 Z M28.0685714,13.9075244 L28.0685714,12.3456196 L27.7038943,12.3456196 L27.2844457,13.4199392 L26.864877,12.3456196 L26.5,12.3456196 L26.5,13.9075244 L26.7575132,13.9075244 L26.7575132,12.7293611 L27.1508807,13.7451078 L27.4178907,13.7451078 L27.8112681,12.7267901 L27.8112681,13.9075244 L28.0685714,13.9075244 Z",
    id: "Shape",
    fill: "#F79E1B"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramMasterCard40);
export default __webpack_public_path__ + "static/media/pictogramMasterCard40.027eb39efd95a4771218a1dd6e603d96.svg";
export { ForwardRef as ReactComponent };